<template>
  <div class="col-md-8 "   id="medicalInformation">
    <v-row>
      <v-col cols="8">
        <h1 class="text-left mb-0" style="color:black;"> {{$t("medical_information.title")}}</h1> <br/>
        <p class="text-left mb-0">{{ $t("medical_information.description") }}</p>
      </v-col>
    </v-row>
    <br/>
    <v-col cols="12" md="12">    
      </v-col>
       <v-col cols="12" md="12">    
      </v-col>
    <v-row>
      <v-col cols="12" md="3" style="padding:0;" class="respon">
            <v-select
                :items="events"
                v-model="eventSelect"
                item-text="eventName"
                item-key="events"
                item-value="id"
                dense outlined
                :label="$t('medical_information.select')"
                return-object
                @change="selectEvent"
                :no-data-text="$t('common.no_data')"
            ></v-select>
      </v-col>
      <v-col cols="12" md="9" class="respon">    
      </v-col>
      <v-col cols="12" md="3" style="padding:0;" class="respon"> 
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('medical_information.filter')"
          hide-details
          dense outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="respon">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :search="search"
          :items="registeredParticipants"
          dense
          item-key="registeredParticipantId"
          :footer-props="{
            'items-per-page-text': $t('dataTable.rowsPerPageText'),
            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
          }"
          :no-data-text="$t('dataTable.noDataText')"
          :no-results-text="$t('dataTable.no_matching_records')"
          :headerProps="{
            'sort-by-text': $t('dataTable.sortByText')
          }"
        >
         <template v-slot:[`item.view`]="{ item }">
              <v-icon small class="mr-2" @click="view(item)">fa far fa-eye</v-icon>
            </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-snackbar v-model="snack" :color="color_snack">{{ msg_snack }}</v-snackbar>
    <v-dialog
      v-model="dialog"
      width="800"
    >
      <v-card>
        <v-card-title>
          <span class="headLine"> {{$t("medical_information.emergency_information_racer_name", {name: Name})}}</span>
        </v-card-title>
        <br/>
        <v-card-text>
          <v-tabs
            v-model="tab"
            background-color="transparent"
            fixed-tabs 
          >
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab href="#contact">
                    {{ $t("medical_information.emergency_contact") }}
                  </v-tab>
                  <v-tab href="#information" >
                    {{ $t("medical_information.medical_information") }}
                  </v-tab>
          </v-tabs>
            <v-tabs-items v-model="tab">
                  <v-tab-item value="contact" class="pa-2">
                       <v-card class="text-left mb-2" max-width="750" v-for="item in emergencyContacts" :key="item.emergencyContactId || item.id">
                        <v-card-text class="text-left">
                          <h3 >
                            {{ item.firstName+" "+item.lastName }}
                          </h3>
                          <h5>
                            <i class="fa fa-phone"></i>
                            {{ item.homePhone }}
                          </h5>
                          <h5>
                            <i class="fa fa-mobile"></i>
                            {{ item.cellPhone }}
                          </h5>
                          <h5>
                            <i class="far fa-at"></i>
                            {{ item.email }}
                          </h5>
                        </v-card-text>
                      </v-card>    
                      <p class="text-left pa-4" v-if="emergencyContacts.length === 0">
                        {{ $t("medical_information.no_emergency_contacts") }}
                      </p>
                  </v-tab-item>
                  <v-tab-item value="information" class="pa-2">
                    <v-card class="text-left mb-2" max-width="750" v-for="item in medicalInformation" :key="item.emergencyInformationId || item.id">
                        <v-card-text class="text-left" >
                          <h3 >
                            {{ item.condition }}
                          </h3>
                          <p class="text-center">{{item.description}}</p>
                        </v-card-text>
                      </v-card>    
                      <p class="text-left pa-4" v-if="medicalInformation.length === 0">
                        {{ $t("medical_information.no_medical_information") }}
                      </p>
                  </v-tab-item>
                 
            </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
    <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')" @cancel="dialogNotification=false;" @agree="deleteItem" type='warning'/>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";

export default {
  name:"MedicalInformation",
  components: {SGSNotificationConfirm},
  mixins: [apiCalls],
  data(){
    return{
      buttonColor: "#000",
      singleSelect: false,
      selected: [],
      events:[],
      eventSelect:'',
      msg_snack: '',
      snack: false,
      color_snack: 'success',
      search: '',
      userCurrent: null,
      dialogNotification: false,
      item: null,
      registeredParticipants :[],
      dialog: false,
      tab: null,
      emergencyContacts:[],
      medicalInformation:[],
      Name: '',
      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
    }
  },
  methods:{
    async view(item){

      const responseInformation = await this.api(
        "get",
        "/api/v1/promoter/medic/information/" + this.eventSelect.id+ "/"+ item.userId
      );
      const message = responseInformation && responseInformation.message ? responseInformation.message : {};
      this.emergencyContacts = message.emergencyContacts || (Array.isArray(message) ? message.filter((item) => item && item.firstName) : []);
      this.medicalInformation = message.medicalInformation || [];

      this.Name = item.name
      this.tab = "contact"
      this.dialog= true
    },
    editItem(event){
      //window.location.href = "/admin/eventDetails?eventId="+event.id;
      this.$router.push({ name: "WaiverEdit",  params: { id:  event.id} });
    },
    editItem3(event){
      //window.location.href = "/admin/eventDetails?eventId="+event.id;
      this.$router.push({ name: "WaiverEdit",  params: { id:  event.id, step3: 3} });
    },
    async getUser() {
      const getUserCurrent = await this.api("get", "/api/v1/users/current");
      this.userCurrent = getUserCurrent.message;
    },
    async getEvents() {
      const response = await this.api(
        "get",
        "/api/v1/promoter/geteventsbypromoter"
      );
      this.events = response[0].map((el) => {
        return {
          ...el,
          eventName: this.$escapeHtml.decode(el.eventName)
        };
      });
      this.eventSelect = this.events[0]
      this.selectEvent();
    },
    async selectEvent() {
      const response = await this.api(
        "get",
        "/api/v1/promoter/medic/" + this.eventSelect.id
      );
      let vm = this
      this.registeredParticipants=[];
      response.message.forEach(function (e) {
        vm.registeredParticipants.push({
          registeredParticipantId: e.registeredParticipantId,
          name: e.firstName+" "+e.lastName,
          nameClasse: e.nameClasse,
          number: e.number,
          userId: e.userId
        });
      });
    }
  },
  computed:{
    headers(){
      return [
        {
          text: this.$t('medical_information.view'),
          sortable: false,
          value: 'view',
        },
        { text: this.$t('medical_information.race_number'), value: 'number', sortable: true  },
        { text: this.$t('medical_information.racer_name'), value: 'name', sortable: true  },
        { text: this.$t('medical_information.class_name'), value: 'nameClasse', sortable: true  }
      ]
    }
  },
  created: function() {
    this.buttonColor = process.env.VUE_APP_BUTTON_COLOR;
    this.getUser();
  },
  watch: {
    userCurrent(val) {
      if(val) {
        this.getEvents();
      }
    }
  }
}
</script>

<style>


#medicalInformation{
        margin: 0 20% 0 18%;
}

@media (min-width: 500px) {
  #contentMain{
    overflow-x:hidden;
  }
}
@media (min-width: 500px) and (max-width: 950px) {
  .respon {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 80%;
  }
}
@media (max-width: 500px) {
  #medicalInformation{
        margin: 0;
  }
}

.v-data-table {
 margin: 0 !important;
}
.v-application .text-center{
  text-align: justify !important;
}

@media (min-width: 1024px) {
  .breadcrumb-c{display: none !important;}
}
</style>
